export type ApiState = '' | 'PENDING' | 'SUCCESS' | 'ERROR'

export const NOT_CALLED: ApiState = '';
export const API_CALL_PENDING: ApiState = 'PENDING';
export const API_CALL_SUCCESSFUL: ApiState = 'SUCCESS';
export const API_CALL_ERROR: ApiState = 'ERROR';

export const PAGE_SIZE_MAX = 2147483647;